import { createSlice } from "@reduxjs/toolkit";
import {
  createCashPayment,
  checkCashPaymentStatus,
  createOnlinePayment,
} from "./paymentThunks";

const initialState = {
  loading: false,
  payment: null,
  // Cash payment
  cashPaymentData: null,
  status: "pending",
  payment_status: "unpaid",
  error: null,
};  

const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    clearCashPayment: (state) => {
      state.cashPaymentData = null;
      state.status = "pending";
      state.payment_status = "unpaid";
      state.error = null;
    },
    
    resetPayment: (state) => {
      state.loading = false;
      state.payment = null;
      state.error = null;
    },

  },

  extraReducers: (builder) => {
    builder

      // ---------- CASH PAYMENT ----------
      .addCase(createCashPayment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createCashPayment.fulfilled, (state, action) => {
        state.loading = false;
        state.cashPaymentData = action.payload;
        state.status = action.payload.status || "pending";
        state.payment_status = action.payload.payment_status || "unpaid";
      })
      .addCase(createCashPayment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ---------- CHECK CASH STATUS ----------
      .addCase(checkCashPaymentStatus.fulfilled, (state, action) => {
        if (action.payload.status) {
          state.status = action.payload.status;
        }
        if (action.payload.payment_status) {
          state.payment_status = action.payload.payment_status;
        }
      })
      .addCase(checkCashPaymentStatus.rejected, (state, action) => {
        state.error = action.payload;
      })

      // ---------- ONLINE PAYMENT ----------
      .addCase(createOnlinePayment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createOnlinePayment.fulfilled, (state, action) => {
        state.loading = false;
        state.payment = action.payload;
      })
      .addCase(createOnlinePayment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearCashPayment, resetPayment } = paymentSlice.actions;
export default paymentSlice.reducer;
